export default {"src":"/_next/static/media/truck.fb367f36.svg","height":42,"width":40,"blurWidth":0,"blurHeight":0};